import { axios, base, LONG_REQUEST_TIMEOUT } from '../http';

/** 宿舍楼分页 */
export const getBuildingsListPage = (params) => {
  return axios.get(`${base}/api/Buildings/get`, { params: params });
};

/** 楼栋树 */
export const getBuildingsTree = (params) => {
  return axios.get(`${base}/api/Buildings/GetTree`, { params: params });
};

/** 住宿容量统计 */
export const getBuildingsStatistic = (params) => {
  return axios.get(`${base}/api/Buildings/GetStatistic`, { params: params });
};

export const removeBuildings = (params) => {
  return axios.delete(`${base}/api/Buildings/delete`, { params: params });
};

export const editBuildings = (params) => {
  return axios.put(`${base}/api/Buildings/put`, params);
};

export const addBuildings = (params) => {
  return axios.post(`${base}/api/Buildings/post`, params);
};

export const getLiveDataPage = (params) => {
  return axios.get(`${base}/api/Buildings/GetLiveData`, { params: params });
};

export const savaLiveData = (params) => {
  return axios.post(`${base}/api/Buildings/SavaLiveData`, params);
};

/** 学生/教师入住或退宿 */
export const bindBed = (params) => {
  return axios.post(`${base}/api/Buildings/BindBed`, params);
};

/** 调宿 */
export const changeBed = (params) => {
  return axios.post(`${base}/api/Buildings/ChangeBed`, params);
};

export const batchUnbindLiveData = (params) => {
  return axios.post(`${base}/api/Buildings/BatchUnbindLiveData`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
    skipGlobalHttpErrorToast: true,
  });
};

/** 导出入住明细（JSON，前端写 Excel） */
export const exportLiveOccupancy = (params) => {
  return axios.get(`${base}/api/Buildings/ExportLiveOccupancy`, { params: params });
};

/** 按模板批量导入入住 */
export const importLiveOccupancy = (data, params) => {
  return axios.post(`${base}/api/Buildings/ImportLiveOccupancy`, data, {
    params: params,
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

/** 初始化住宿区间 */
export const initBedAssignments = (params) => {
  return axios.post(`${base}/api/Buildings/InitBedAssignments`, null, {
    params: params,
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

/** 含床位房间列表（看板卡片，支持全校搜索） */
export const getRoomsWithBeds = (params) => {
  return axios.get(`${base}/api/Rooms/GetWithBeds`, { params: params });
};

/** 数据汇总下钻明细分页 */
export const getOccupancyDetails = (params) => {
  return axios.get(`${base}/api/Buildings/GetOccupancyDetails`, { params: params });
};

/** 差异化批量生成房间 */
export const batchAddRoomsCustom = (params) => {
  return axios.post(`${base}/api/Rooms/BatchAddCustom`, params);
};

/** 批量删除房间；force=true 时有人入住也强制退宿后删除 */
export const batchDeleteRooms = (roomIds, force = false) => {
  return axios.post(`${base}/api/Rooms/BatchDelete`, roomIds, { params: { force } });
};

/** 变动记录分页 */
export const getDormChangeRecords = (params) => {
  return axios.get(`${base}/api/DormChangeRecord/get`, { params: params });
};

/** 变动记录统计 */
export const getDormChangeStats = (params) => {
  return axios.get(`${base}/api/DormChangeRecord/GetStats`, { params: params });
};

/** 发布缺失的第一版规则（运维兼容；日常改配置会自动即时生效） */
export const publishDormFirstVersions = (params) => {
  return axios.post(`${base}/api/DormAttendance/PublishFirstVersions`, null, { params: params });
};

/** @deprecated 日常无需调用；保存考勤时间后会自动 SyncLiveRule */
export const publishDormVersion = (params) => {
  return axios.post(`${base}/api/DormAttendance/PublishVersion`, null, { params: params });
};

/** 设备绑定列表 */
export const getDormDeviceBindings = (params) => {
  return axios.get(`${base}/api/DormDeviceBinding/GetList`, { params: params });
};

/** 保存设备绑定 */
export const saveDormDeviceBinding = (params) => {
  return axios.post(`${base}/api/DormDeviceBinding/Save`, params);
};

/** 停用设备绑定 */
export const disableDormDeviceBinding = (params) => {
  return axios.post(`${base}/api/DormDeviceBinding/Disable`, null, { params: params });
};

/** 宿舍考勤 V3 学校配置 */
export const getDormAttendanceV3Config = (params) => {
  return axios.get(`${base}/api/DormAttendanceV3/GetConfig`, { params });
};

export const saveDormAttendanceV3Config = (data) => {
  return axios.post(`${base}/api/DormAttendanceV3/SaveConfig`, data);
};

/** 宿舍早离、晚归准点规则 */
export const getDormAttendanceV3Rules = (params) => {
  return axios.get(`${base}/api/DormAttendanceV3/GetRules`, { params });
};

export const getDormAttendanceV3GradeOptions = (params) => {
  return axios.get(`${base}/api/DormAttendanceV3/GetGradeOptions`, { params });
};

export const saveDormAttendanceV3Rule = (data) => {
  return axios.post(`${base}/api/DormAttendanceV3/SaveRule`, data);
};

/** 宿舍考勤日报及明细 */
export const disableDormAttendanceV3Rule = (params) => {
  return axios.post(`${base}/api/DormAttendanceV3/DisableRule`, null, { params: params });
};

export const getDormAttendanceV3Summary = (params) => {
  return axios.get(`${base}/api/DormAttendanceV3/GetDailySummary`, { params });
};

/** 宿舍楼栋树形汇总 */
export const getDormAttendanceV3BuildingTreeSummary = (params) => {
  return axios.get(`${base}/api/DormAttendanceV3/GetBuildingTreeSummary`, { params });
};

export const getDormAttendanceV3Details = (params) => {
  return axios.get(`${base}/api/DormAttendanceV3/GetDailyDetails`, { params });
};

export const getDormAttendanceV3Presence = (params) => {
  return axios.get(`${base}/api/DormAttendanceV3/GetPresence`, { params });
};

export const reviewDormAttendanceV3 = (data) => {
  return axios.post(`${base}/api/DormAttendanceV3/Review`, data);
};

/** 宿舍考勤人工处理记录 */
export const getDormAttendanceV3ReviewLogs = (params) => {
  return axios.get(`${base}/api/DormAttendanceV3/GetReviewLogs`, { params });
};

/** 考勤结果分页 */
export const getDormAttendanceRecords = (params) => {
  return axios.get(`${base}/api/DormAttendance/GetRecords`, { params: params });
};

// ========== 用电参数（历史放在本模块，页面仍从此引用） ==========

export const getPowerEquipmentParameterListPage = (params) => {
  return axios.get(`${base}/api/PowerEquipmentParameter/get`, {
    params: params,
  });
};

export const removePowerEquipmentParameter = (params) => {
  return axios.delete(`${base}/api/PowerEquipmentParameter/delete`, {
    params: params,
  });
};

export const editPowerEquipmentParameter = (params) => {
  return axios.put(`${base}/api/PowerEquipmentParameter/put`, params);
};

export const addPowerEquipmentParameter = (params) => {
  return axios.post(`${base}/api/PowerEquipmentParameter/post`, params);
};

export const AddDeviceEquipmentParameter = (params) => {
  return axios.post(
    `${base}/api/PowerEquipmentParameter/AddDeviceEquipmentParameter`,
    params,
  );
};

export const DelDeviceEquipmentParameter = (params) => {
  return axios.post(
    `${base}/api/PowerEquipmentParameter/DelDeviceEquipmentParameter`,
    params,
  );
};

export const GetDeviceListById = (params) => {
  return axios.get(`${base}/api/PowerEquipmentParameter/GetDeviceListById`, {
    params: params,
  });
};

/** 下发参数 */
export const SyucParameter = (params) => {
  return axios.post(
    `${base}/api/PowerEquipmentParameter/SyucParameter`,
    params,
  );
};

// ========== 定时开关机 ==========

export const getPowerOnOffScheduleListPage = (params) => {
  return axios.get(`${base}/api/PowerOnOffSchedule/get`, { params: params });
};

export const addPowerOnOffSchedule = (params) => {
  return axios.post(`${base}/api/PowerOnOffSchedule/post`, params);
};

export const editPowerOnOffSchedule = (params) => {
  return axios.put(`${base}/api/PowerOnOffSchedule/put`, params);
};

export const deletePowerOnOffSchedule = (params) => {
  return axios.delete(`${base}/api/PowerOnOffSchedule/Delete`, {
    params: params,
  });
};

// ========== 宿舍检查（DormInspect）==========

/** 后台模板树：campusId=-1 全部校区；>=0 精确校区 */
export const getDormInspectTemplate = (params) => {
  return axios.get(`${base}/api/DormInspect/GetTemplate`, { params });
};

/** 兼容旧名：按学校/校区拉模板树（前端本地过滤/组装） */
export const getDormInspectCategoryListPage = (params) => {
  const schoolId = params.schoolId || params.departmentId;
  const campusRaw = params.campusId;
  const campusId =
    campusRaw === null || campusRaw === undefined || campusRaw === '' || Number(campusRaw) < 0
      ? -1
      : Number(campusRaw);
  return getDormInspectTemplate({ schoolId, campusId });
};

/** 一级类下拉：从模板树取 Level=1 */
export const getDormInspectParentsByDepartment = (params) => {
  const schoolId = params.schoolId || params.departmentId;
  const campusId =
    params.campusId === null || params.campusId === undefined || params.campusId === ''
      ? 0
      : Number(params.campusId);
  return getDormInspectTemplate({ schoolId, campusId }).then(res => {
    const tree = (res.data && res.data.response) || [];
    const parents = (tree || []).filter(c => Number(c.Level) === 1);
    return {
      ...res,
      data: {
        ...(res.data || {}),
        response: parents,
      },
    };
  });
};

export const addDormInspectCategory = (params) => {
  const body = {
    ...params,
    SchoolId: params.SchoolId || params.schoolId || params.DepartmentId || params.departmentId,
  };
  return axios.post(`${base}/api/DormInspect/SaveCategory`, body);
};

export const editDormInspectCategory = (params) => {
  const body = {
    ...params,
    SchoolId: params.SchoolId || params.schoolId || params.DepartmentId || params.departmentId,
  };
  return axios.post(`${base}/api/DormInspect/SaveCategory`, body);
};

export const deleteDormInspectCategory = (params) => {
  return axios.post(`${base}/api/DormInspect/DeleteCategory`, null, { params });
};

/** 二级类下三级项：从模板树中取当前二级的 Items */
export const getDormInspectItemListPage = (params) => {
  const categoryId = params.categoryId || params.CategoryId;
  const schoolId = params.schoolId || params.departmentId;
  const campusId =
    params.campusId === null || params.campusId === undefined || params.campusId === ''
      ? -1
      : Number(params.campusId);
  return getDormInspectTemplate({ schoolId, campusId }).then(res => {
    const tree = (res.data && res.data.response) || [];
    let items = [];
    const walk = (nodes) => {
      (nodes || []).forEach(n => {
        if (String(n.Id) === String(categoryId)) {
          items = n.Items || [];
        }
        if (n.Children && n.Children.length) walk(n.Children);
      });
    };
    walk(tree);
    return {
      ...res,
      data: {
        ...(res.data || {}),
        response: {
          data: items,
          dataCount: items.length,
          PageSize: items.length || 10,
        },
      },
    };
  });
};

export const addDormInspectItem = (params) => {
  return axios.post(`${base}/api/DormInspect/SaveItem`, params);
};

export const editDormInspectItem = (params) => {
  return axios.post(`${base}/api/DormInspect/SaveItem`, params);
};

export const deleteDormInspectItem = (params) => {
  return axios.post(`${base}/api/DormInspect/DeleteItem`, null, { params });
};

/** 批量导入宿舍检查项（一/二级 + 三级） */
export const importDormInspectItems = (params) => {
  return axios.post(`${base}/api/DormInspect/ImportDormInspectItems`, params);
};

/** 关联值周三级项下拉（二级→三级） */
export const getDormDutyInspectItemOptions = (params) => {
  return axios.get(`${base}/api/DormInspect/GetDutyInspectItemOptions`, {
    params,
  });
};

/** 宿舍检查记录分页 */
export const getDormInspectRecords = (params) => {
  return axios.get(`${base}/api/DormInspect/GetRecords`, { params });
};

export const getDormInspectRecordDetail = (params) => {
  return axios.get(`${base}/api/DormInspect/GetRecordDetail`, { params });
};

export const deleteDormInspectRecord = (params) => {
  return axios.post(`${base}/api/DormInspect/DeleteRecord`, null, { params });
};

export const exportDormInspectRecords = (params) => {
  return axios.get(`${base}/api/DormInspect/ExportRecords`, {
    params,
    responseType: 'blob',
  });
};

/** 宿舍排名（周/月/学期） */
export const getDormInspectRoomRank = (params) => {
  return axios.get(`${base}/api/DormInspect/GetRoomRank`, { params });
};

export const exportDormInspectRoomRank = (params) => {
  return axios.get(`${base}/api/DormInspect/ExportRoomRank`, {
    params,
    responseType: 'blob',
  });
};

/** 班级排名（宿舍检查口径） */
export const getDormInspectClassRank = (params) => {
  return axios.get(`${base}/api/DormInspect/GetClassRank`, { params });
};

export const exportDormInspectClassRank = (params) => {
  return axios.get(`${base}/api/DormInspect/ExportClassRank`, {
    params,
    responseType: 'blob',
  });
};

/** 住宿看板当日已检/扣分覆盖（按楼） */
export const getDormInspectBoardOverlay = (params) => {
  return axios.get(`${base}/api/DormInspect/GetBoardOverlay`, { params });
};

/** 宿舍检查人员列表（BizScope 含宿舍） */
export const getDormInspectStaffList = (params) => {
  return axios.get(`${base}/api/DormInspectStaff/GetList`, { params });
};

/** 保存检查人员（命中则改权 Upsert） */
export const saveDormInspectStaff = (params) => {
  return axios.post(`${base}/api/DormInspectStaff/Save`, params);
};

/** 移除宿舍权限（仅降权，不删值周权） */
export const removeDormInspectStaff = (params) => {
  return axios.post(`${base}/api/DormInspectStaff/Remove`, null, { params });
};

/** 从宿管导入预览 */
export const previewDormInspectHostelAdmins = (params) => {
  return axios.post(`${base}/api/DormInspectStaff/PreviewHostelAdmins`, params);
};

/** 从宿管导入保存 */
export const importDormInspectHostelAdmins = (params) => {
  return axios.post(`${base}/api/DormInspectStaff/ImportHostelAdmins`, params);
};
